import React, { useEffect, useState, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { DataContext } from "../../context/data-context";

type NotificationsProps = {
  className?: string;
};
const Notifications: React.FC<NotificationsProps> = ({ className }) => {
  const dataContext = useContext(DataContext);
  const { notifications } = dataContext;
  const location = useLocation();
  const history = useHistory();
  const [unread, setUnread] = useState<null | string>(null);

  useEffect(() => {
    if (notifications) {
      setUnread(notifications);
    }
  }, [notifications]);

  const handleHref = () => {
    if (location.pathname === "/notifications") {
      if (history.length < 1) {
        history.push({
          pathname: `/`,
        });
      } else {
        history.goBack();
      }
      return;
    }
    history.push({
      pathname: `/notifications`,
    });
  };

  return (
    <button
      className={`btn text-white nav-item dropdown notifications no_focus ${className}`}
      onClick={handleHref}
      aria-label="Go to notifications"
    >
      <i className="far fa-bell" aria-hidden="true"></i>
      {unread !== "0" ? (
        <span className="sr-only visually-hidden">
          You have {unread} unread notifications
        </span>
      ) : null}

      <span
        className="notifications_badge badge badge-danger"
        id="notifications_badge"
        aria-hidden="true"
      >
        {unread !== "0" ? unread : null}
      </span>
    </button>
  );
};

export default Notifications;
